import { render, staticRenderFns } from "./MarkOfShame.vue?vue&type=template&id=7941a657&"
import script from "./MarkOfShame.vue?vue&type=script&setup=true&lang=js&"
export * from "./MarkOfShame.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MarkOfShame.vue?vue&type=style&index=0&id=7941a657&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7941a657')) {
      api.createRecord('7941a657', component.options)
    } else {
      api.reload('7941a657', component.options)
    }
    module.hot.accept("./MarkOfShame.vue?vue&type=template&id=7941a657&", function () {
      api.rerender('7941a657', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/MarkOfShame/MarkOfShame.vue"
export default component.exports